import { Component, OnInit, Optional } from '@angular/core';
import { ControlContainer, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseFpxFormComponent } from '@fpx/core';
import { ProcessShellService } from '../services/process-shell.service';
import { ProfilePicResultPageHelper, ProfilePicResultPageState } from './profile-pic-result-page.helper';


@Component({
  selector: 'app-profile-pic-result-page',
  templateUrl: './profile-pic-result-page.component.html',
  styleUrls: ['./profile-pic-result-page.component.scss'],
  providers: [
    ProfilePicResultPageHelper
  ]
})
export class ProfilePicResultPageComponent extends BaseFpxFormComponent<ProfilePicResultPageHelper, ProfilePicResultPageState> {

  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private _router: Router,
    public formHelper: ProfilePicResultPageHelper,
    public _processShellService: ProcessShellService

  ) {
    super(formBuilder, _router, controlContainer, formHelper);
  }
  

}
